import { Component, OnDestroy } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subscription, debounceTime, take } from 'rxjs';
import { UserSettings } from "fakturnia-shared";
import { APIResponse } from 'fakturnia-shared';
import { ApiService } from 'shared/services/api.service';
import { SettingsService } from 'shared/services/settings.service';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { SnackbarService } from 'shared/services/snackbar.service';

@Component({
  selector: 'default-comments',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatInputModule, MatCheckboxModule, MatButtonModule],
  templateUrl: './default-comments.component.html',
  styleUrl: './default-comments.component.scss'
})
export class DefaultCommentsComponent implements OnDestroy {
  private _subscriptions: Subscription[] = [];
  control = new FormControl('');
  constructor(
    private apiService: ApiService,
    private settingsService: SettingsService,
    private _snackbarService: SnackbarService
  ) {
    this._subscriptions.push(this.settingsService.getUserSettings().subscribe({
      next: (data: UserSettings) => {
        this.control.setValue(data.settings.autocomplete.comments, { emitEvent: false})
      }
    }))
  }

  saveChanges() {
    this.apiService.updateDefaultComments(this.control.value)
    .pipe(take(1))
    .subscribe({
      next: (data:APIResponse) => {

        this.settingsService.refreshSettings()

        if(!data.success) {
          
          this._snackbarService.showSnackBar(
            "Nie udało się zapisać zmian",
            "success", 
            4000
          )

          return
        }

        this._snackbarService.showSnackBar(
          "Zapisano zmiany",
          "success", 
          4000
        )
      }
    })
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach(sub=>sub.unsubscribe())
  }
}
